import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../style/policy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="policy-container">
      <button className="policy-back-btn" onClick={() => navigate("/")}>
        Back
      </button>
      <h1>Privacy</h1>
      <div className="policy-content">
        <p>
          This Privacy Policy explains how GR GPT collects, uses, and protects information
          when you use the platform.
        </p>

        <h2>Information We Collect</h2>
        <p>
          We may collect basic account information such as your name, email address, login
          details, and usage-related information such as device type, browser, IP address,
          session logs, and interactions with the platform.
        </p>

        <h2>How We Use Information</h2>
        <ul>
          <li>To provide access to GR GPT features and maintain your account.</li>
          <li>To process chat requests and improve response quality, reliability, and safety.</li>
          <li>To monitor platform usage, prevent abuse, and troubleshoot technical issues.</li>
          <li>To communicate important updates, support responses, or account-related notices.</li>
        </ul>

        <h2>Chat Content</h2>
        <p>
          Queries submitted to GR GPT may be processed to generate responses, improve service
          performance, and support debugging or auditing. Users should avoid submitting highly
          sensitive personal, financial, or confidential information unless necessary.
        </p>

        <h2>Cookies and Analytics</h2>
        <p>
          GR GPT may use cookies, local storage, and analytics tools to keep sessions active,
          remember preferences, and understand how the service is used.
        </p>

        <h2>Sharing of Information</h2>
        <p>
          We do not sell your personal information. Information may be shared with service
          providers or infrastructure partners only as needed to operate, secure, and improve
          GR GPT, or where required by law.
        </p>

        <h2>Data Retention</h2>
        <p>
          We retain account, usage, and support information for as long as reasonably necessary
          for operations, legal compliance, security, and service improvement.
        </p>

        <h2>Your Choices</h2>
        <p>
          You may request account updates or deletion, subject to applicable legal, security,
          and operational retention requirements.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          This policy may be updated from time to time. Continued use of GR GPT after updates
          means you accept the revised policy.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy-related questions, visit our <Link to="/contact">Contact Support</Link> page or contact us at <strong>grgptsupport@gmail.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
